import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { CommonService } from '../../../services/common.service';
import { CompanyPasswordPolicy } from '../../../modules/authentication/services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vrm-password-policy-info',
  templateUrl: './password-policy.component.html',
  styleUrls: ['./password-policy.component.scss'],
})
export class PasswordPolicyComponent implements OnInit {
  @Input() passwordPolicy: CompanyPasswordPolicy;
  @Input() passwordResetError: boolean;

  acceptableSpecialChars: string;
  lengthPolicies: Array<string> = [];
  mustContainPolicies: Array<string> = [];
  otherPolicies: Array<string> = [];

  constructor(public cService: CommonService, private translateService: TranslateService) {}

  ngOnInit() {
    if (this.passwordPolicy) {
      if (this.passwordPolicy.passwordAllowedSpecialChars) {
        const replacementChar = new RegExp('', 'g');
        this.acceptableSpecialChars = this.passwordPolicy.passwordAllowedSpecialChars.replace(replacementChar, ' ');
      }
    }

    this.translateService.use(this.cService.selectedLanguage.code);

    this.translatePasswordPolicy();
  }

  translatePasswordPolicy() {
    if (this.passwordPolicy) {
      this.lengthPolicies = [];
      this.mustContainPolicies = [];
      this.otherPolicies = [];

      this.translateService.get('SECURITY').subscribe({
        next: (translations) => {
          this.lengthPolicies.push(`${translations.minimumLength}: ${this.passwordPolicy.passwordMinLength}`);

          this.lengthPolicies.push(`${translations.maximumLength}: ${this.passwordPolicy.passwordMaxLength}`);

          if (this.passwordPolicy.passwordRequireNumeric) {
            this.mustContainPolicies.push(translations.number);
          }

          if (this.passwordPolicy.passwordRequireUppercase) {
            this.mustContainPolicies.push(translations.uppercaseCharacter);
          }

          if (this.passwordPolicy.passwordRequireLowercase) {
            this.mustContainPolicies.push(translations.lowercaseCharacter);
          }

          if (this.passwordPolicy.passwordRequireSpecialChars) {
            const replacementChar = new RegExp('', 'g');
            this.acceptableSpecialChars = this.passwordPolicy.passwordAllowedSpecialChars.replace(replacementChar, ' ');
          }

          if (this.passwordPolicy.passwordNotUseLastNumPasswords) {
            let lastPwReuseLimit = this.passwordPolicy.passwordNotUseLastNumPasswords;

            if (lastPwReuseLimit === 1) {
              this.otherPolicies.push(translations.mustNotBeLastPassword);
            } else {
              let translatedPwReusePolicy = this.translateService.getParsedResult(
                translations,
                'mustNotBeOneOfLastXPasswords',
                { value: lastPwReuseLimit }
              );
              this.otherPolicies.push(translatedPwReusePolicy);
            }
          }

          if (this.passwordPolicy.passwordMinHoursBetweenChange) {
            let minHoursBeforeChange = this.passwordPolicy.passwordMinHoursBetweenChange;

            if (minHoursBeforeChange === 1) {
              this.otherPolicies.push(translations.cannotBeChangedUntilOneHourLater);
            } else {
              let prefixTranslation = translations.cannotBeResetUntil;
              let suffixTranslation = translations.hoursAfterLastChange.toLowerCase();
              this.otherPolicies.push(`${prefixTranslation} ${minHoursBeforeChange} ${suffixTranslation}`);
            }
          }

          if (this.passwordPolicy.passwordExpiryDays) {
            let translatedExpiryDaysPolicy = this.translateService.getParsedResult(
              translations,
              'passwordExpiresInXDays',
              { value: this.passwordPolicy.passwordExpiryDays }
            );
            this.otherPolicies.push(translatedExpiryDaysPolicy);
          }
        },
      });
    }
  }
}
